module.exports = __webpack_public_path__ + "static/map-background-a66a64deaaa85ee2617016b0151ec6bd.png";